import axios from "axios";

axios.defaults.withCredentials = true;
const sameHostBackend = `${window.location.protocol}//${window.location.hostname}:8080`;
const backendBase = (process.env.REACT_APP_BACKEND_URL || sameHostBackend).replace(/\/$/, "");
export const API = /\/api\/index\.php$/i.test(backendBase) ? backendBase : `${backendBase}/api`;
export const money = (n) => new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(n || 0);
export const shortMoney = (n) => n >= 1e6 ? `${(n / 1e6).toLocaleString("id-ID", { maximumFractionDigits: 1 })} jt` : `${Math.round((n || 0) / 1e3)} rb`;
export const monthLabel = (m, opts = { month: "long", year: "numeric" }) => new Date(`${m}-01T00:00:00`).toLocaleDateString("id-ID", opts);
